import { IPortalTag } from './types';

export const convertTag = ({ ...data }: IPortalTag<string>): IPortalTag<Date> => ({
  ...data,
  created_at: new Date(data.created_at),
  updated_at: new Date(data.updated_at),
});
